export default {
  "content": "<path d=\"M20.275 11.946a5.89 5.89 0 01-8.329 8.329L9.872 18.2l1.414-1.414 2.074 2.074a3.889 3.889 0 105.5-5.5l-2.074-2.074L18.2 9.872l2.075 2.074z\" fill=\"#7B61FF\"/><path d=\"M16.97 15.555l-.707.707-.708.708L7.03 8.444l.708-.707.707-.708 8.527 8.526z\" fill=\"#7B61FF\"/><path d=\"M3.724 3.724a5.89 5.89 0 018.33 0L14.128 5.8l-1.414 1.414-2.075-2.074a3.89 3.89 0 00-5.5 5.5l2.075 2.075L5.8 14.127l-2.076-2.074a5.89 5.89 0 010-8.329z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};